const state = {
    modalShow: false,
    timestamp: 0,
};
const mutations = {
    setModalShow(state, isShow) {
        state.modalShow = isShow;
    },
    setTimestamp(state, timestampValue) {
        state.timestamp = timestampValue;
    },
};
export const alcoholModule = {
    state,
    mutations,
    namespaced: true,
};
